import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize Sentry before React rendering
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (import.meta.env.VITE_SENTRY_ENABLED === 'true' && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
